import { userApiClient } from '../HttpClient';
import { ICreateRoomRequest, ICreateRoomReponse } from '../../app/model/hostModel'; // Re-using ICreateRoomRequest/Reponse for now

export async function createRoom(request: ICreateRoomRequest): Promise<ICreateRoomReponse> {
  try {
    const client = await userApiClient;
    const response = await client.post<ICreateRoomReponse>(`/api/pg_tenant/longterm/rooms/`, request);
    return response;
  } catch (error: any) {
    console.error("Failed to create room in pg_tenant_service:", error);
    throw error;
  }
}

export async function getPropertyRules(propertyId: string): Promise<any> {
  const client = await userApiClient;
  return client.get(`/api/pg_tenant/property/${propertyId}/rules/`);
}

export async function savePropertyRules(propertyId: string, data: any): Promise<any> {
  const client = await userApiClient;
  return client.post(`/api/pg_tenant/property/${propertyId}/rules/`, data);
}

export async function sendTenantInvite(tenantId: string): Promise<{ message: string; whatsapp_url: string }> {
  const client = await userApiClient;
  return client.post(`/api/pg_tenant/longterm/tenants/${tenantId}/send-invite/`, {});
}

export async function getTenantAgreement(tenantId: string): Promise<any> {
  const client = await userApiClient;
  return client.get(`/api/pg_tenant/longterm/tenants/${tenantId}/agreement/`);
}

export async function saveTenantAgreement(tenantId: string, data: any): Promise<any> {
  const client = await userApiClient;
  return client.post(`/api/pg_tenant/longterm/tenants/${tenantId}/agreement/`, data);
}

export async function getPgSaleListings(): Promise<any> {
  const client = await userApiClient;
  return client.get('/api/pg_tenant/pg-sale/');
}

export async function createPgSaleListing(data: any): Promise<any> {
  const client = await userApiClient;
  return client.post('/api/pg_tenant/pg-sale/', data);
}

export async function updatePgSaleListing(listingId: string, data: any): Promise<any> {
  const client = await userApiClient;
  return client.patch(`/api/pg_tenant/pg-sale/${listingId}/`, data);
}

export async function deletePgSaleListing(listingId: string): Promise<any> {
  const client = await userApiClient;
  return client.delete(`/api/pg_tenant/pg-sale/${listingId}/`);
}

export async function getSubscriptionStatus(): Promise<{
  plan: string;
  tenant_count: number;
  max_tenants: number | null;
  max_marketplace_contacts: number | null;
  renewal_date: string | null;
  subscription_expired?: boolean;
  is_paid?: boolean;
  trial_active?: boolean;
  trial_days_left?: number | null;
  trial_end_date?: string | null;
}> {
  const client = await userApiClient;
  return client.get('/api/pg_tenant/subscriptions/status/');
}

export type PlanType = 'starter' | 'growth' | 'pro' | 'enterprise' | 'custom';

export async function initiateSubscription(planType: PlanType): Promise<{
  subscription_id?: string;
  order_id?: string;
  id?: string;
  short_url?: string;
  amount?: number;
  [key: string]: any;
}> {
  const client = await userApiClient;
  return client.post('/api/pg_tenant/subscriptions/initiate/', { plan_type: planType });
}

export async function verifySubscription(
  razorpayId: string,
  planType: PlanType,
  isOrder = false,
): Promise<{ plan: string }> {
  const client = await userApiClient;
  return client.post('/api/pg_tenant/subscriptions/verify/', {
    razorpay_subscription_id: razorpayId,
    plan_type: planType,
    is_order: isOrder,
  });
}

export async function getPropertyVacateNotices(propertyId: string): Promise<any[]> {
  const client = await userApiClient;
  return client.get(`/api/pg_tenant/property/${propertyId}/vacate-notices/`);
}
